// extracted by mini-css-extract-plugin
export default {"containerx":"Home_containerx__B4CcW","containeClose":"Home_containeClose__mfBlD","containertext":"Home_containertext__vx1GM"};